import { View } from 'react-native'; 
import React, { useState, useEffect, useRef } from 'react'; 
import Modal  from "react-native-modal";
import { useDispatch, useSelector } from 'react-redux'; 

import RepaymentText from './repaymentText'; 
import { tdsActions } from './tdsRedux/tds.actions'; 
import { backgroundTdsArr, backgroundTdsArrBackPage } from './backgroundTdsArr'; 
import getPlatformType from '../../helpers/getPlatform'; 
import { navigateAction } from '../../helpers/navigationHelpers';
import BackGroundGenerator from '../LandingPages/common/BackGroundGenerator'; 
import { Container, BoxShadow, Typography, LineSaperator, ButtonWrapper } from './style'; 
import { ODSText } from '../../../openbrix-design-system/ui/atoms/ODSText';
import { useTheme } from '@emotion/react';
import { ODSInput } from '../../../openbrix-design-system/ui/atoms/ODSInput';
import ODSRadioButton from '../../../openbrix-design-system/ui/atoms/ODSRadioButton';
import ODSButton from '../../../openbrix-design-system/ui/atoms/ODSButton/index.native';
import { ODSModal } from '../../../openbrix-design-system/ui/atoms/ODSModal/ODSModal.web';
 
const custodialRespond = (props) => { 
  const dispatch = useDispatch(); 
  const {colors}=useTheme();
  const layoutType = getPlatformType(); 
  const [type, setType] = useState('web'); 
  const [tenancy, setTenancy] = useState({}); 
  const [tenants, setTenants] = useState([]);
  const [repayment, setRepayment] = useState({}); 
  const [agreedStatus, setAgreedStatus] = useState('dont_agree'); 
  const [modal, setModal] = useState({ visible: false, text: '' }); 
  const respondSuccess =  useSelector((state) => state.tds?.respondSuccess);
  const repaymentResponse = useSelector((state) => state.tds?.repaymentProposal); 
  const scrollViewRef=useRef(null)

  useEffect(() => {
    dispatch(tdsActions.getDepositRepaymentProposal(props.route.params.case_id, props?.route?.params?.tenancy_id, props?.route?.params?.dan));
  }, []);
 
  useEffect(() => { 
    if (repaymentResponse) { 
      setTenants(repaymentResponse?.tenancy?.tenants)
      setTenancy(repaymentResponse?.tenancy); 
      setRepayment(repaymentResponse?.repayment?.repaymentProposal)
    }
  }, [repaymentResponse]); 

  useEffect(() => { 
    if (respondSuccess) {
      navigateAction(props.navigation, 'Custodial Dashboard', { 'tenancy_id': props?.route?.params?.tenancy_id, 'dan': props?.route?.params?.dan })
    }
  }, [respondSuccess]); 
  
  const renderDepositSection = () => { 
    return ( 
      <View> 
        <Typography 
           id={"TOTAL_DEPOSIT_HELD"}
        color={'#194592'} size={'25px'} bold={400}> 
          Total Deposit Held 
        </Typography> 
        <ODSText type='h2' marginBottom={32} marginTop={16} textAlign='center' color='#001A96'> £ {tenancy?.tenancy?.deposit_amount} </ODSText>
        <LineSaperator /> 
         <View style={{flexDirection:layoutType=="phone"?'column':'row',justifyContent:'space-between',alignItems:'center',marginTop:32,marginBottom:64}}>
         <View>
          <ODSText textAlign={layoutType=='phone' &&  'center'} color='#001A96' type='sm-bold'>Tenancy end date</ODSText>
          <ODSText color={colors.text.secondary} marginTop={6} type='sm'>Supplied by landlord</ODSText>
          </View>
          <View>
            <ODSInput
            leftIcon='TB-Calendar'
            editable={false}
            value={repayment?.tenancy_end_date_landlord }
            />
          </View>

         </View>
       </View> 
    ); 
  }; 
 
  const renderPreviewSection = () => { 
    return ( 
      <BoxShadow bottom={'40px'} top={'40px'}> 
         {renderDepositSection()} 
        {/* <Typography bottom={'3px'} align={'left'} color={'#194592'} size={'23px'} bold={700}> 
          Repayment to Tenants 
        </Typography>  */}
        <ODSText type='h6' color='#001A96'>Repayment to Tenants </ODSText>
         
         { tenants?.map(tenant=>{
            return (
              <RepaymentText  colValue={tenant.amount_to_tenant_rr_ll} label={tenant.fullname} />  
            )
         })}
 
        <RepaymentText colValue={repayment?.amount_to_tenants_landlord_rrll}  label={'Total'}  lColor={'#194592'} />


        <ODSText type='h6' marginTop={48} color='#001A96'>Repayment to Landlord </ODSText>
        <Typography align="left" top={'8px'} color={'#000000'} size={'20px'} bold={500}> 
          {tenancy?.property?.membername}
        </Typography> 
        <RepaymentText colHeading={'Landlord/Agent Request'} colValue={repayment?.amount_to_agent_cleaning} label={'Cleaning'} /> 
        <RepaymentText colValue={repayment?.amount_to_agent_damage} label={'Damage to Property/Contents'} /> 
        <RepaymentText colValue={repayment?.amount_to_agent_redecoration} label={'Redecoration'} /> 
        <RepaymentText colValue={repayment?.amount_to_agent_gardening} label={'Gardening'} /> 
        <RepaymentText colValue={repayment?.amount_to_agent_rent_arrears} label={'Rent Arrears'} /> 
        <RepaymentText colValue={repayment?.amount_to_agent_other} label={'Other or Unknonw'} /> 
        <RepaymentText colValue={repayment?.amount_to_agent_rr} label={'Total'} lColor={'#194592'} /> 
        <> 
        
            <LineSaperator style={{marginTop:54}}/> 

           <ODSText type='h6' marginTop={48} color='#001A96'>Response to Repayment Request</ODSText>
        <Typography align="left" top={'8px'} bottom={'20px'} color={'#000000'} size={'18px'} bold={500}> 
        Please select one of the following options: 
        </Typography> 
        <View style={{gap:20}}>
        <ODSRadioButton
          label={'I agree with the repayment request '}
          checked={agreedStatus == 'agree'?true:false}
          onPress={()=>setAgreedStatus('agree')}
          color={'#001A96'}
        />
          <ODSRadioButton
          label={'I agree with the repayment request and wish to change the amount each tenant receives '}
          checked={agreedStatus == 'agree1'?true:false}
          onPress={()=>setAgreedStatus('agree1')}
          color={'#001A96'}
        />
          <ODSRadioButton
          label={`I do not agree with the repayment request and wish to resolve the dispute using the scheme’s dispute resolution mechanism`}
          checked={agreedStatus == 'agree2'?true:false}
          onPress={()=>setAgreedStatus('agree2')}
          color={'#001A96'}
        />
          <ODSRadioButton
          label={'I do not agree with the repayment request and wish to resolve the dispute using the scheme’s dispute resolution mechanism'}
          checked={agreedStatus == 'agree3'?true:false}
          onPress={()=>setAgreedStatus('agree3')}
          color={'#001A96'}
        />
        </View>
        <ODSButton
        disabled={agreedStatus=="dont_agree"}
        restStyle={{backgroundColor:agreedStatus=='dont_agree'?"grey":'#FF41C0',height:44,alignSelf:layoutType=='phone'?'center':'flex-end',marginTop:48}}
        onPress={() => { 
          scrollViewRef.current.scrollTo({ y: 0, animated: true });
          setModal({ 
            visible: true, 
            text: '', 
          }); 
        }} 
        >
          Submit
          </ODSButton>

 
          {/* <ButtonWrapper 
            top={'51px'} 
            color={'#FFFFFF'} 
            bcolor={agreedStatus == 'agree' ? '#A4D4A2' : '#194592'} 
            radius={'11px'} 
            onPress={() => { 
              setAgreedStatus('agree'); 
            }} 
          > 
            <Typography 
              color={agreedStatus == 'agree' ? '#A4D4A2' : '#194592'} 
              size={'19px'} 
              bold={800} 
            > 
              I agree with the repayment request 
            </Typography> 
          </ButtonWrapper>  */}
          {/* <ButtonWrapper 
            top={'51px'} 
            color={'#FFFFFF'} 
            bcolor={agreedStatus == 'agree1' ? '#A4D4A2' : '#194592'} 
            radius={'11px'} 
            onPress={() => { 
              setAgreedStatus('agree1'); 
            }} 
          > 
            <Typography 
              color={agreedStatus == 'agree1' ? '#A4D4A2' : '#194592'} 
              size={'19px'} 
              bold={800} 
            > 
              I agree with the repayment request and wish to change the amount each tenant receives 
            </Typography> 
          </ButtonWrapper>  */}
          {/* <ButtonWrapper 
            top={'51px'} 
            color={'#FFFFFF'} 
            bcolor={agreedStatus == 'agree2' ? '#A4D4A2' : '#194592'} 
            radius={'11px'} 
            onPress={() => { 
              setAgreedStatus('agree2'); 
            }} 
          > 
            <Typography 
              color={agreedStatus == 'agree2' ? '#A4D4A2' : '#194592'} 
              size={'19px'} 
              bold={800} 
            > 
              I do not agree with the repayment request and wish to resolve the dispute using the
              scheme’s dispute resolution mechanism
            </Typography> 
          </ButtonWrapper>  */}
          {/* <ButtonWrapper 
            top={'51px'} 
            color={'#FFFFFF'} 
            bcolor={agreedStatus == 'agree3' ? '#A4D4A2' : '#194592'} 
            radius={'11px'} 
            onPress={() => { 
              setAgreedStatus('agree3'); 
            }} 
          > 
            <Typography 
              color={agreedStatus == 'agree3' ? '#A4D4A2' : '#194592'} 
              size={'19px'} 
              bold={800} 
            > 
              I do not agree with the repayment request and wish to resolve the dispute 
              using the scheme’s dispute resolution mechanism
            </Typography> 
          </ButtonWrapper>  */}
        </> 
 
        {/* <ButtonWrapper 
          top={'75px'} 
          onPress={() => { 
            scrollViewRef.current.scrollTo({ y: 0, animated: true });
            setModal({ 
              visible: true, 
              text: '', 
            }); 
          }} 
        > 
          <Typography color={'#FFFFFF'} size={'19px'} bold={800}> 
            {'SUBMIT'} 
          </Typography> 
        </ButtonWrapper>  */}
      </BoxShadow> 
    ); 
  }; 
 
  return ( 
    <> 
      <BackGroundGenerator 
      scrollViewRef={scrollViewRef} 
        isTds 
        props={props} 
        layoutType={(data) => { 
          setType(data); 
        }} 
        isTLYF 
        paddingtop={80}
        infoIcon 
        backgroundArr={backgroundTdsArrBackPage} 
        isBack={true} 
        backNavigation={() => props?.navigation?.goBack()} 
      > 
        <Container> 
 
          {renderPreviewSection()} 
        </Container> 
        <ODSModal isVisible={modal.visible} transparent={true} coverScreen={false} hasBackdrop={false} backdropOpacity={0} onBackdropPress={() => setModal({ visible: false, text: '', })} style={{ margin: 0, width: '100%', flex: 1, backgroundColor: '#00000080', paddingVertical: layoutType == 'phone' ? '5%' : '20%', paddingHorizontal: layoutType == 'phone' ? '8%' : '3%' }} > 
          <View style={{ width: layoutType == 'phone' ? '365px' : '500px', backgroundColor: '#FAFAFA', borderRadius: 20, overflow: 'hidden', alignSelf: 'center', padding: layoutType == 'phone' ? '5%' : '2%' }} > 

            <ODSText textAlign='center' type='h6' color={'#001A96'} marginBottom={32} >Response to Repayment Request </ODSText>
            {agreedStatus == 'agree' ? ( 
              <> 
              <ODSText type='sm' color={colors.text.secondary} >{`You are agreeing to the agent/landlord’s repayment request. This means that we will pay the deposit in accordance with their request.

Please confirm this is what you want to happen to the deposit.`}</ODSText>
              </> 
            ) : (        
               <ODSText type='sm' color={colors.text.secondary} > This selected response action will have to be continued on the website </ODSText>
            )} 

            <ODSButton
             width={235}
             onPress={() => {
              if(agreedStatus == 'agree') {
                dispatch(tdsActions.updateDepositRepaymentProposal(props.route.params.case_id));
              } else {
                window.open('https://www.tenancydepositscheme.com/log-in/', "_blank")
              }
              setModal({ visible: false, text: '' });
            }}
            restStyle={{ width:235,backgroundColor: '#FF41C0', height: 44, alignSelf: 'center', marginTop: 32  }}
            >
            {agreedStatus == 'agree' ? 'Continue' : 'Open website'} 
            </ODSButton>
            <ODSButton
            type='secondary'
            onPress={() => { 
              setModal({ 
                visible: false, 
                text: '', 
              }); 
            }} 
            restStyle={{ width:235,borderColor: '#FF41C0',borderWidth:1 ,height: 44, alignSelf: 'center', marginTop: 16  }}
            >
              Cancel
            </ODSButton>
            {/* <ButtonWrapper 
              color={'#638ACC'} 
              width={'100%'} 
              style={{ marginTop: 30 }} 
              onPress={() => {
                if(agreedStatus == 'agree') {
                  dispatch(tdsActions.updateDepositRepaymentProposal(props.route.params.case_id));
                } else {
                  window.open('https://www.tenancydepositscheme.com/log-in/', "_blank")
                }
                setModal({ visible: false, text: '' });
              }}
            > 
              <Typography color={'#FFFFFF'} size={'19px'} bold={700}> 
                {agreedStatus == 'agree' ? 'Continue' : 'Open website'} 
              </Typography> 
            </ButtonWrapper> 
            <ButtonWrapper 
              bcolor={'#638ACC'} 
              color={'#FFFFFF'} 
              width={'100%'} 
              style={{ marginTop: 30 }} 
              onPress={() => { 
                setModal({ 
                  visible: false, 
                  text: '', 
                }); 
              }} 
            > 
              <Typography color={'black'} size={'19px'} bold={700}> 
                Cancel 
              </Typography> 
            </ButtonWrapper>  */}
          </View> 
        </ODSModal> 
      </BackGroundGenerator> 
    </> 
  ); 
}; 
 
export default custodialRespond; 
